import React from 'react';
import UIComponent from 'ui-components/ui-component';
import SelectGrid from 'ui-components/select-grid/select-grid';
import './default-style/select-group.scss';

/**
 * canCancel {Boolean} 是否可取消
 * canMultiple {Boolean} 是否可多选
 * selectedTagName {any} 单选选中的标签
 * selectedTagNames {[any]} 多选选中的标签
 * onValueChange {Function} (remove, add, isManual, component)=>{}
 * onValuesChange {Function} (tagNames, isManual, component)=>{}
 */
export default class SelectGroup extends UIComponent{
    get className(){
        let className = super.className;
        return className?className:"default-select-group";
    }
    set className(className){
        super.className = className;
    }

    get isRegisterEvent(){
        return this.props.isRegisterEvent === true ? true : false;
    }

    get controlledProps(){
        return [...super.controlledProps,"canCancel","canMultiple","selectedTagName","selectedTagNames"];
    }

    //-------------------------------------------------内部属性及方法-------------------------------------------------
    declareVars(){
        super.declareVars();
        this._totalTagNames = [];
        this._oldTagNames = null;
        this._isManual = false;
        this._oldTagName = undefined;
        this.onValueChange = null;
        this.onValuesChange = null;

        this._valuesChangeDelay = UIComponent.fns.throttle((isManual)=>{
            const isEqual = UIComponent.fns.ObjectFns.isEqual;
            try{
                this.state.selectedTagNames = UIComponent.fns.ArrayFns.intersection(
                    this._totalTagNames,this.state.selectedTagNames
                );
            }catch (e) {}
            if(!isEqual(this._oldTagNames, this.selectedTagNames)){
                if(this.props.onValuesChange){
                    this.props.onValuesChange([...this.selectedTagNames],isManual,this);
                }
                if(this.onValuesChange){
                    this.onValuesChange([...this.selectedTagNames],isManual,this);
                }
                this._oldTagNames = [...this.selectedTagNames];
            }
        },100,{leading:false});
    }

    gridPointClick (tagName, component){
        this._isManual = true;
        if(this.canMultiple){
            //----------取消选择----------
            if(this.selectedTagNames.indexOf(tagName)!==-1){
                this.selectedTagNames = UIComponent.fns.ArrayFns.without(this.selectedTagNames,tagName);
            }else{
                this.selectedTagNames = UIComponent.fns.ArrayFns.union(this.selectedTagNames,[tagName]);
            }
        }else{
            //----------切换选择项----------
            if(this.selectedTagName!==tagName){
                this.selectedTagName = tagName;
            }else if(this.selectedTagName===tagName){
                //----------如果可取消----------
                if(this.canCancel){
                    this.selectedTagName = null;
                }
            }
        }
    };

    valueChange(){
        if(this.canMultiple){
            //----------触发valuesChange----------
            this._valuesChangeDelay(this._isManual);
        }else{
            if(this.selectedTagName!==null || this.selectedTagName!== undefined){
                if(this._totalTagNames.length && this._totalTagNames.indexOf(this.selectedTagName)===-1){
                    this.state.selectedTagName = null;
                }
            }
            if(this._oldTagName !== this.selectedTagName){
                let component = this.refs[this.selectedTagName || this._oldTagName];
                if(this.props.onValueChange){
                    this.props.onValueChange(
                        this._oldTagName===undefined ? null : this._oldTagName,
                        this.selectedTagName, this._isManual, component || null
                    );
                }
                if(this.onValueChange){
                    this.onValueChange(
                        this._oldTagName===undefined ? null : this._oldTagName,
                        this.selectedTagName, this._isManual, component || null
                    );
                }
                this._oldTagName = this.selectedTagName;
            }
        }
        this._isManual = false;
    }

    initChildren(){
        this._totalTagNames = [];
        let _children = [];
        React.Children.map(this.children, (child,index)=>{
            if(UIComponent.fns.isSpecificReactType(child,SelectGrid)){
                let props = {...child.props};
                const TypesCheck = UIComponent.fns.TypesCheck;
                if(!TypesCheck.isString(props.tagName) && !TypesCheck.isNumber(props.tagName)){
                    props.tagName = "select-grid-"+index;
                    console.warn("添加至Group的SelectGrid组件的tagName必须为字符串或数字~！");
                }
                props.key = index;
                props.onPointClick = UIComponent.fns.constObject(this,"_point_click",this.gridPointClick.bind(this));
                if(this.canMultiple){
                    props.isSelected = this.selectedTagNames.indexOf(props.tagName)!==-1;
                }else{
                    props.isSelected = this.selectedTagName === props.tagName;
                }
                props.isControlled = true;
                this._totalTagNames.push(props.tagName);
                let Type = child.type;
                _children.push(<Type {...props} ref={props.tagName}/>);
            }else{
                _children.push(child);
            }
        });
        return _children;
    }

    //-------------------------------------------------对外属性-------------------------------------------------
    get canCancel(){
        if(this.canMultiple){
            return true;
        }
        this.state.canCancel = this.state.canCancel === true ? true : false;
        return this.state.canCancel;
    }
    set canCancel(canCancel){
        if(this.canMultiple){
            return;
        }
        this.setState({canCancel:canCancel})
    }

    get canMultiple(){
        this.state.canMultiple = this.state.canMultiple === true ? true : false;
        return this.state.canMultiple;
    }
    set canMultiple(canMultiple){
        this.setState({canMultiple:canMultiple});
    }

    get selectedTagName(){
        return this.state.selectedTagName || null;
    }
    set selectedTagName(selectedTagName){
        this.setState({selectedTagName:selectedTagName});
    }

    get selectedTagNames(){
        this.state.selectedTagNames = this.state.selectedTagNames || [];
        return this.state.selectedTagNames;
    }
    set selectedTagNames(selectedTagNames){
        this.setState({selectedTagNames:selectedTagNames});
    }

    getSelectGrid(tagName){
        return this.refs[tagName];
    }
    //-------------------------------------------------组件结构及生命周期-------------------------------------------------
    getChildren(){
        return UIComponent.fns.constElement(this,"_children",
            this.statesHasChanged("canCancel","canMultiple","children","selectedTagName","selectedTagNames"),
            ()=>{
                if(this.statesHasChanged("canMultiple")){
                    if(this.canMultiple){
                        this._oldTagNames = null;
                        if(!this.statesHasChanged("selectedTagNames")){
                            this.state.selectedTagNames = [];
                        }
                    }else{
                        this._oldTagName = undefined;
                        if(!this.statesHasChanged("selectedTagName")){
                            this.state.selectedTagName = null;
                        }
                    }
                }
                return this.initChildren();
            }
        );
    }
    domDidChange(){
        super.domDidChange();
        this.valueChange();
    }
}
